import { AbstractControl, AsyncValidatorFn } from '@angular/forms';
export function imageRatioValidator(ratio: number = 1): AsyncValidatorFn {
	return (control: AbstractControl) => {
		return new Promise(resolve => {
			if (!control.value) {
				resolve(null);
				return;
			}

			const files = control.value;
			if (!(files instanceof FileList) || files.length === 0) {
				resolve(null);
				return;
			}

			const fileRatiosPassed = [];
			for (let i = 0; i < files.length; i++) {
				fileRatiosPassed.push(getFileRatio(files[i], ratio));
			}
			Promise.all(fileRatiosPassed).then(results => {
				const err = results.every(passed => passed) ? null : { imageRatio: true };
				resolve(err);
				return;
			});
		});
	};
}

function getFileRatio(file: File, ratio: number): Promise<boolean> {
	return new Promise<boolean>(resolve => {
		const reader = new FileReader();
		reader.onloadend = () => {
			const img = new Image();
			img.onload = () => {
				const actualRatio =
					img.naturalHeight > img.naturalWidth
						? img.naturalWidth / img.naturalHeight
						: img.naturalHeight / img.naturalWidth;
				resolve(ratio === actualRatio);
				return;
			};
			img.src = reader.result as string;
		};
		reader.readAsDataURL(file as Blob);
	});
}
